import { prefix } from '@goldwasserexchange/react-topmodel';
export var formPrefixer = prefix('Form');
